import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Routes } from '../../definitions/routes';

export function setupRequisicao(): void {
  const modules = [{
    entry: 'historico-requisicoes',
    id: 'historico-requisicoes',
    name: 'beneficiary.historico-requisicoes',
    route: Routes.HISTORICO_REQUISICOES,
    order: 1,
    closeable: true,
  }];

  applicationModuleRegistry.registerGroup({
    entry: 'requisicao',
    id: 'requisicao',
    name: 'beneficiary.requisicao',
    modules,
    order: 8,
  });
}
